import styled from "styled-components";
import css from "@styled-system/css";
import { Button, Icon, Popover } from "@bca/ui-library";

import ClaimsMissingItemsLinks from "./ClaimsMissingItemsLinks";

const ClaimsButton = styled(Button)`
  width: 42px;
  height: 42px;
  padding: 0;
  z-index: 3;
  &:not([disabled]):hover {
    svg {
      fill: white;
    }
    :active {
      background-color: #2196f3;
      border: none;
    }
  }
  ${css({
    backgroundColor: "primary-white",
    border: "solid 1px rgba(241, 241, 241, 0.5)",
  })}
`;

const ClaimsPopover: React.FunctionComponent = () => (
  <Popover
    offsetX={0}
    offsetY={14}
    paddingX={6}
    paddingY={6}
    placement="bottom left"
    type="menu"
    width="100vw"
    zIndex={2}
  >
    <ClaimsButton>
      <Icon
        name="ellipsis-h"
        color="primary-light-blue"
        width={18}
        height={18}
      ></Icon>
    </ClaimsButton>
    <ClaimsMissingItemsLinks />
  </Popover>
);

export default ClaimsPopover;
